import script from "./StandardAdminPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StandardAdminPage.vue?vue&type=script&setup=true&lang=js"

import "./StandardAdminPage.vue?vue&type=style&index=0&id=ee71e622&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee71e622"]])

export default __exports__